import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readArticleCategories, deleteArticleCategory } from '../actions/entity.article.category';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { green, red } from '@ant-design/colors';

function ArticleCategories(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);

    const deleteArticleCategoryAction = (id) => {
        dispatch(deleteArticleCategory(params.entityId, id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('entityArticleCategories.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('entityArticleCategories.columns.isRoot'),
            dataIndex: 'isRoot',
            key: 'isRoot',
            render: (text, record) => {
                if (typeof record.isRoot !== 'undefined' && record.isRoot === true) {
                    return <CheckCircleTwoTone twoToneColor={green[5]} />;
                } else {
                    return <CloseCircleTwoTone twoToneColor={red[5]} />;
                }
            }
        },
        {
            title: t('entityArticleCategories.columns.parent'),
            dataIndex: 'parent',
            key: 'parent',
            render: (text, record) => {
                if (typeof record.parent !== 'undefined' && record.parent !== null) {
                    return record.parent.slug;
                } else {
                    return '-';
                }
            }
        },
        {
            title: t('entityArticleCategories.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('entityArticleCategories.columns.status.enabled');
                } else {
                    return t('entityArticleCategories.columns.status.disabled');
                }
            }
        },
        {
            title: t('entityArticleCategories.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('entityArticleCategories.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button size="small" type="primary" href={`/entity/${params.entityId}/article-category/${record.id}`}>{t('entityArticleCategories.actions.edit')}</Button>
                <Popconfirm
                    title={t('entityArticleCategories.actions.delete-confirm')}
                    onConfirm={() => deleteArticleCategoryAction(record.id)}
                    okText={t('entityArticleCategories.actions.delete-ok')}
                    cancelText={t('entityArticleCategories.actions.delete-cancel')}
                >
                    <Button size="small" type="primary" danger>{t('entityArticleCategories.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readArticleCategories(params.entityId)).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch, params.entityId]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate(`/entity/${params.entityId}/dashboard`)}
                        title={t('entityArticleCategories.title')}
                        subTitle={t('entityArticleCategories.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={`/entity/${params.entityId}/article-category`}>{t('entityArticleCategories.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        size='small'
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default ArticleCategories;